import { Component, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { ClientLocation } from '../models/clientLocation';
import { ClientService } from '../services/client.service';

@Component({
  selector: 'app-question-flow',
  templateUrl: './question-flow.component.html',
  styleUrls: ['./question-flow.component.less']
})
export class QuestionFlowComponent implements OnInit, AfterViewInit {
  ngAfterViewInit(): void {
    
  }
  simplebool : boolean;
  DOB: Date;
  locations : Array<ClientLocation> = new Array<ClientLocation>();
  selectedLocation : ClientLocation = undefined;
  constructor(public clientSrv : ClientService, public changer : ChangeDetectorRef) {
   }

  ngOnInit() {
    this.clientSrv.GetClientLocations(1).subscribe((results : any)=>{
      this.locations = results.map((v) => {return v;});
      this.selectedLocation = this.locations[0];
      this.changer.detectChanges();
    });
  }

  update(val : any){
    console.log(val);
  }

}
